"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const property_1 = require("@genesys/property");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const calculations_1 = require("@munters/calculations");
const initalState = {
    humidityInput: calculateDensity(property_1.PropertyValueSet.fromString("pressure=101325:Pascal;temperature=20:Celsius;humidity=7.29:GramPerKilogram;density=0:KilogramPerCubicMeter")),
    humidityOutput: property_1.PropertyValueSet.fromString("humidity1=7.2937:GramPerKilogram;humidity2=7.2937:GramPerKilogram;humidity3=7.2937:GramPerKilogram;humidity4=7.2937:GramPerKilogram;humidity5=7.2937:GramPerKilogram")
};
function reducer(state = initalState, action) {
    switch (action.type) {
        case "humidity-conversion/SET-PROPERTIES-INPUT":
            return Object.assign(Object.assign({}, state), { humidityInput: calculateDensity(action.payload), humidityOutput: setHumidity(property_1.PropertyValueSet.getAmount("humidity", action.payload)) });
        case "humidity-conversion/CALCULATE-DENSITY":
            return Object.assign({}, state);
        case "main/TAB_REMOVED": {
            if (action.payload.type !== "HumidityConversionTabSubject") {
                return state;
            }
            return initalState;
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
function calculateDensity(pvs) {
    const pressure = property_1.PropertyValueSet.getAmount("pressure", pvs);
    const temperature = property_1.PropertyValueSet.getAmount("temperature", pvs);
    const humidity = property_1.PropertyValueSet.getAmount("humidity", pvs);
    const density = calculations_1.Physics.RP1485.AshraeHb2009.calculateDensityOfMoistAirMixture(temperature, pressure, humidity);
    return property_1.PropertyValueSet.merge(property_1.PropertyValueSet.fromProperty("density", property_1.PropertyValue.fromAmount(density)), pvs);
}
function setHumidity(humidity) {
    let pvs = property_1.PropertyValueSet.setAmount("humidity1", humidity, property_1.PropertyValueSet.Empty);
    pvs = property_1.PropertyValueSet.setAmount("humidity2", humidity, pvs);
    pvs = property_1.PropertyValueSet.setAmount("humidity3", humidity, pvs);
    pvs = property_1.PropertyValueSet.setAmount("humidity4", humidity, pvs);
    pvs = property_1.PropertyValueSet.setAmount("humidity5", humidity, pvs);
    return pvs;
}
//# sourceMappingURL=reducer.js.map